<template>
  <div>
    <a-form layout="inline">
      <a-form-item>
        <a-button v-permission="PERMISSIONS.NOTICE_CREATE" @click="createNotice">新建通知</a-button>
      </a-form-item>
    </a-form>
    <a-table bordered :data-source="dataSource" :columns="columns" :pagination="false" :loading="loading" :rowKey="record => record.id">
      <template slot="site" slot-scope="record">
        <div>
          {{ siteOptions[record.site_id] }}
        </div>
      </template>
      <template slot="operation" slot-scope="record">
        <div class="button-box">
          <a-button @click="showNotice(record)">展示</a-button>
          <a-button v-permission="PERMISSIONS.NOTICE_UPDATE" @click="updateNotice(record)">编辑</a-button>
          <a-popconfirm title="确认删除这条消息?" ok-text="Yes" cancel-text="No" @confirm="deleteNotice(record)">
            <a-button v-permission="PERMISSIONS.NOTICE_DELETE">删除</a-button>
          </a-popconfirm>
        </div>
      </template>
    </a-table>
    <div style="display: flex; justify-content: flex-end; margin-top: 10px">
      <a-pagination
        v-model="currentPage"
        :total="total"
        :showSizeChanger="true"
        :showQuickJumper="true"
        :show-total="total => `共 ${total} 条`"
        @change="pageChange"
        @showSizeChange="pageChange"
      />
    </div>
    <a-modal v-model="noticeVisible" title="展示" width="900px" :footer="null">
      <div class="ql-container ql-snow">
        <div class="ql-editor">
          <div v-html="content" />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { deleteNotice, getNoticeList, getSiteList } from '@/api/notice'

export default {
  data() {
    return {
      columns: [
        {
          title: 'id',
          dataIndex: 'id',
          width: '10%'
        },
        {
          title: '站点',
          key: 'site',
          scopedSlots: { customRender: 'site' },
          width: '15%'
        },
        {
          title: '描述',
          dataIndex: 'remark',
          width: '30%'
        },
        {
          title: '创建人',
          dataIndex: 'create_user',
          width: '10%'
        },
        {
          title: '创建时间',
          dataIndex: 'create_date',
          width: '15%'
        },
        {
          title: '操作',
          key: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      dataSource: [],
      currentPage: 1,
      pageSize: 10,
      total: 1,
      loading: false,
      noticeVisible: false,
      content: '',
      siteOptions: {}
    }
  },
  async mounted() {
    await this.getSiteList()
    await this.getNoticeList()
  },
  methods: {
    getNoticeList() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      this.loading = true
      return getNoticeList(params)
        .then(res => {
          this.dataSource = res.data.currentList
          this.total = res.data.totalSize
          this.loading = false
        })
        .catch(() => {
          this.dataSource = []
          this.total = 0
          this.loading = false
        })
    },
    getSiteList() {
      return getSiteList().then(res => {
        this.siteOptions = res.data.reduce((agg, e) => (agg[e.id] = e.name) && agg, {})
      })
    },
    showNotice(data) {
      this.content = data.content
      this.noticeVisible = true
    },
    pageChange(page, pageSize) {
      this.currentPage = page
      this.pageSize = pageSize
      this.getNoticeList()
    },
    createNotice() {
      this.$router.push({ name: 'CreateNotice', query: { type: 'create' } })
    },
    updateNotice(data) {
      this.$router.push({ name: 'CreateNotice', query: { type: 'update', id: data.id } })
    },
    deleteNotice(data) {
      deleteNotice({ id: data.id }).then(() => {
        this.getNoticeList()
      })
    }
  }
}
</script>

<style scoped>
.button-box {
  display: flex;
  justify-content: space-evenly;
}
</style>
